import React from 'react'

const About = () => {
  return (
    <section className='section about-section'>
      <h1 className='section-title'>about us</h1>
      <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quas repudiandae, sit sed accusamus, dolorum architecto earum dolor quod delectus veritatis illum expedita magni ipsum ad, incidunt deleniti a distinctio omnis!</p>
    </section>
  )
}

export default About
